import React, { useState, useEffect } from "react";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow/index";
import TextInputOnRow2 from "components/GenericComponent/TextInputOnRow/v2";
import { DanhSachTaiSanCombo } from "../../../constants/danhSachTaiSanConst";
import StoreApi from "service/storeApi";
import ReactDropdown from "react-dropdown";
import { ThuocTinhTaiSan2 } from "./ThuocTinhTaiSan2";
import ThuocTinhTaiSanApi from "service/thuocTinhTaiSanApi";
import LoaiTaiSanApi from "service/loaiTaiSanApi";
import { Controller } from "react-hook-form";

export const ThongTinTaiSan2 = ({
  currentForm,
  datanew,
  update,
  TaiSanID,
  errors,
  setErrors,
}) => {
  const { register, control } = currentForm;
  const [dataCombo, setdataCombo] = useState(DanhSachTaiSanCombo.KhoCombo);

  const [dataComboLoaiTs, setdataComboLoaiTs] = useState(
    DanhSachTaiSanCombo.LoaiTaiSanCombo,
  );

  useEffect(() => {
    // console.log(TaiSanID);
    if (typeof TaiSanID === "undefined" || TaiSanID === 0) {
      LoaiTaiSanApi.combo({}).then((response) => {
        const dataComboLoaiTsReturn = response.data.map((item) => ({
          value: item.value,
          label: item.label,
        }));
        setdataComboLoaiTs(dataComboLoaiTsReturn);
        // console.log(dataComboLoaiTsReturn);
        ThuocTinhTaiSanApi.listThuocTinhTaiSan(
          dataComboLoaiTsReturn[0].value,
        ).then((response) => {
          const dataOptionReturn = response.data.map((item) => ({
            TenThuocTinh: item.TenThuocTinh,
            MaThuocTinh: item.MaThuocTinh,
            OptionValue: "",
          }));
          // update({
          //   ...datanew,
          //   LoaiTaiSan: dataComboLoaiTsReturn[0].value,
          //   Options: dataOptionReturn,
          // });
          // console.log("thong tin tai san" + datanew.TaiSanID);
          // console.log(datanew);
          bindDataKho({
            ...datanew,
            LoaiTaiSan: dataComboLoaiTsReturn[0].value,
            Options: dataOptionReturn,
          });
          //console.log(datanew);
        });
      });
    } else {
      LoaiTaiSanApi.combo({}).then((response) => {
        const dataComboLoaiTsReturn = response.data.map((item) => ({
          value: item.value,
          label: item.label,
        }));

        setdataComboLoaiTs(dataComboLoaiTsReturn);
        ThuocTinhTaiSanApi.listThuocTinhTaiSan(
          dataComboLoaiTsReturn[0].value,
        ).then((response) => {
          const dataOptionReturn = response.data.map((item) => ({
            TenThuocTinh: item.TenThuocTinh,
            MaThuocTinh: item.MaThuocTinh,
            OptionValue: "",
          }));

          StoreApi.combo({}).then((response) => {
            const dataComboReturn = response.data.map((item, index) => ({
              value: item.value,
              label: item.StoreName,
            }));
            setdataCombo(dataComboReturn);
            //   dataAddAndEdit.KhoID = dataComboReturn && dataComboReturn[0].value;
          });
        });
      });
    }
  }, []);

  const bindDataKho = (stateUpdate) => {
    StoreApi.combo({}).then((response) => {
      const dataComboReturn = response.data.map((item, index) => ({
        value: item.value,
        label: item.StoreName,
      }));
      setdataCombo(dataComboReturn);
      //   dataAddAndEdit.KhoID = dataComboReturn && dataComboReturn[0].value;
      update({
        ...stateUpdate,
        KhoID: dataComboReturn[0].value,
      });
    });
  };
  const updateTextValue = (field) => (e) => {
    console.log(e, "texxt");
    update({
      ...datanew,
      [field]: e.target.value,
    });

    if (e.target.value === "") {
      setErrors({
        ...errors,
        tenTaiSan: "Nhập tên tài sản!",
      });
    } else {
      setErrors({
        ...errors,
        tenTaiSan: "",
      });
    }
  };
  const updateDropdown = (field) => (e) => {
    //console.log(e.target.value);
    if (field === "LoaiTaiSan") {
      getThuocTinhTaiSan(e.target.value);
    } else
      update({
        ...datanew,
        [field]: e.target.value,
      });
  };

  const updateDropdown1 = (field) => (e) => {
    update({
      ...datanew,
      [field]: e.target.value,
    });
  };

  const getThuocTinhTaiSan = (thuoctinhtaisanId) => {
    ThuocTinhTaiSanApi.listThuocTinhTaiSan(thuoctinhtaisanId).then(
      (response) => {
        // console.log(thuoctinhtaisanId);
        const dataOptionReturn = response.data.map((item) => ({
          TenThuocTinh: item.TenThuocTinh,
          MaThuocTinh: item.MaThuocTinh,
          OptionValue: "",
        }));

        update({
          ...datanew,
          LoaiTaiSan: thuoctinhtaisanId,
          Options: dataOptionReturn,
        });
      },
    );
  };

  return (
    <>
      <div className="col-md-12">
        <div className="row">
          <div className="col-md-4">
            <TextInputOnRow
              labelClass="label-control color7-bold"
              inputClass="form-control input-sm"
              wrapperClass="form-group"
              labelText="Mã tài sản"
              disabled="disabled"
              ref={register}
              inputProps={{
                name: "MaTaiSan",
                value: datanew.MaTaiSan,
                onChange: updateTextValue("MaTaiSan"),

                control: control,
              }}
            ></TextInputOnRow>
          </div>

          <div className="col-md-4">
            <TextInputOnRow
              labelClass="label-control color7-bold"
              inputClass="form-control input-sm"
              wrapperClass="form-group"
              labelText="Tên tài sản"
              inputProps={{
                name: "TenTaiSan",
                onChange: updateTextValue("TenTaiSan"),
                value: datanew.TenTaiSan,
              }}
            ></TextInputOnRow>
            {errors.tenTaiSan && (
              <span className="canh-bao-red">{errors.tenTaiSan}</span>
            )}
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label for="projectinput1" className="color7-bold">
                Kho
              </label>
              <Controller
                control={control}
                name="KhoID"
                // rules={{ required: "Hãy chọn kho" }}
                render={({ onChange, onBlur, value }) => (
                  <select
                    // onChange={updateDropdown("KhoID")}
                    onChange={(evt) => {
                      onChange(evt);
                      updateDropdown("KhoID")(evt);
                    }}
                    value={datanew.KhoID}
                    defaultValue={datanew.KhoID}
                    className="form-control input-sm"
                  >
                    {dataCombo &&
                      dataCombo.map((item, idx) => (
                        <option value={item.value}>{item.label}</option>
                      ))}
                  </select>
                )}
              />
              {/* <span className="canh-bao-red">
                {errors.KhoID && errors.KhoID.message}
              </span> */}
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label for="projectinput2" className="color7-bold">
                Loại tài sản
              </label>{" "}
              <Controller
                control={control}
                // rules={{ required: "Hãy chọn loại tài sản" }}
                name="LoaiTaiSan"
                render={({ onChange, onBlur, value }) => (
                  <select
                    // onChange={updateDropdown("LoaiTaiSan")}
                    onChange={(evt) => {
                      onChange(evt);
                      updateDropdown("LoaiTaiSan")(evt);
                    }}
                    value={datanew.LoaiTaiSan}
                    defaultValue={datanew.LoaiTaiSan}
                    className="form-control input-sm"
                  >
                    {dataComboLoaiTs &&
                      dataComboLoaiTs.map((item, idx) => (
                        <option value={item.value}>{item.label}</option>
                      ))}
                  </select>
                )}
              />
              {/* <span className="canh-bao-red">
                {errors.LoaiTaiSan && errors.LoaiTaiSan.message}
              </span> */}
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label for="tel-input" className="color7-bold">
                Tình trạng
              </label>
              {/* <ReactDropdown
                options={DanhSachTaiSanCombo.TinhTrangCombo1}
                onChange={updateDropdown1("TinhTrangID")}
                name="TinhTrangID"
                controlClassName="form-control input-sm"
                value={datanew.TinhTrangID}
              /> */}

              <select
                name="nhanviengiaodich"
                className="selectBox form-control input-sm"
                value={datanew.TinhTrangID}
                onChange={updateDropdown1("TinhTrangID")}
              >
                {DanhSachTaiSanCombo.TinhTrangCombo1 &&
                  DanhSachTaiSanCombo.TinhTrangCombo1.map((item, idx) => (
                    <option key={"objComboStore1" + idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label for="projectinput8" className="color7-bold">
                Ghi chú
              </label>
              <textarea
                rows="1"
                className="form-control input-sm text-era"
                name="GhiChu"
                onChange={updateTextValue("GhiChu")}
                value={datanew.GhiChu}
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      {/* <ThuocTinhTaiSan2
        currentForm={currentForm}
        datanew={datanew}
        update={update}
      /> */}
    </>
  );
};
